<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'Nuruddin Naim',
			author: 'Stoman',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-sans text-sm text-gray-500 dark:text-gray-400"
		>
			&copy; {{ copyrightDate }} {{ projectName }}.
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
